/**
 * TASKS.HOME
 * Home page for actions plans
 */
import PageHeader from "@/components/page-header"
import NavApp from "@/nav/nav.app"
import { WithTranslation, withTranslation } from "react-i18next"
import { useState } from "react"
import TasksActionPlansWidget from "@/widgets/tasks-action-plans.widget"
import Button from "@/components/button"
import TasksInviteModal from "@/modals/tasks-invite.modal"

const MODAL_ADD = "MODAL_ADD"

function TasksHomeRoute(props: WithTranslation) {
  const { t } = props
  const [currentModal, setCurrentModal] = useState<string | null>(null)
  return (
    <NavApp>
      {currentModal === MODAL_ADD && <TasksInviteModal onClose={() => setCurrentModal(null)} />}
      <PageHeader title={t("tasks_all")} subtitle={t("tasks_all_help")}>
        <Button isFullWidth className="primary" onClick={() => setCurrentModal(MODAL_ADD)}>
          {t("tasks_invite_managers")}
        </Button>
      </PageHeader>
      <TasksActionPlansWidget />
    </NavApp>
  )
}

export default withTranslation()(TasksHomeRoute)
